var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCssColorido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M8.6 2.7l7.6 85.1L50 97.3l33.8-9.5 7.6-85.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M75.3 30.5l-1 10.7-2.9 32.1L50 79.2l-21.5-5.9-1.4-16.8h10.5l.7 8.7L50 68.4l11.7-3.2 1.6-14.5-36.7.1-1.1-9.9 38.6-.4.8-10.6-40.4.1-.7-9.9h52.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssColorido);
export default __webpack_public_path__ + "static/media/css-colorido.41e3ef692276caacbbdb6bc38e617d75.svg";
export { ForwardRef as ReactComponent };